import { useState } from "react";
import { publishToSocialMedia } from "../utils/socialMediaPublisher";
import { SocialPlatform } from "../components/PostDisplay/socialPlatforms";
import { PostsForFeed } from "../types/api/PostsForFeeds";
import { Post } from "../types/api/Post";

export interface UsePostPublishingParams {
  session: { user: { id: string | null } } | null;
  currentPost?: Post;
  postForFeed?: PostsForFeed;
  onPublishSuccess: (postForFeed: PostsForFeed) => Promise<void>;
}

export interface PostingState {
  [platform: string]: boolean;
}

export function usePostPublishing({
  session,
  currentPost,
  postForFeed,
  onPublishSuccess,
}: UsePostPublishingParams) {
  const [posting, setPosting] = useState<PostingState>({});

  const handleSocialMediaPost = async (
    platform: SocialPlatform,
    postAs?: string | null
  ) => {
    if (!postForFeed || !currentPost) return;

    setPosting((s) => ({ ...s, [postAs || platform]: true }));

    const result = await publishToSocialMedia({
      userId: session?.user.id || null,
      postId: currentPost._id,
      platform,
      postAs,
    });

    if (result.success) {
      await onPublishSuccess(postForFeed);
    }

    setPosting((s) => ({ ...s, [postAs || platform]: false }));
  };

  return {
    posting,
    handleSocialMediaPost,
  };
}
